/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type RestReportDefinitionDto = {
    createdBy?: string;
    createdDate?: string;
    lastModifiedBy?: string;
    lastModifiedDate?: string;
    deleted?: boolean;
    id?: string;
    firmId?: string;
    predefinedId?: string;
    source?: RestReportDefinitionDto.source;
    reasonName?: string;
    label?: string;
}

export namespace RestReportDefinitionDto {

    export enum source {
        SYSTEM = 'SYSTEM',
        USER_DEFINED = 'USER_DEFINED',
    }


}
